import styled from"@emotion/styled";export const CardForm=styled.div`
  padding: 8px;
  iframe {
    overflow: visible;
    width: 100% !important; // Adjusting iframe width to resolve Stripe iframe's 8px overflow causing horizontal scroll.
  }
`;